import { render, staticRenderFns } from "./budget-header-bip.vue?vue&type=template&id=9099978e&"
import script from "./budget-header-bip.vue?vue&type=script&lang=ts&"
export * from "./budget-header-bip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports